module.exports = __webpack_public_path__ + "static/Raleway-MediumItalic-b24c801e0f82e02ffd616d39dbacd1de.woff2";